import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Emails = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.994 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5c-28.167 0-51 1.567-51 3.5s22.833 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M109.723 125.227C99.017 134.434 85.083 140 69.85 140c-17.428 0-33.153-7.284-44.292-18.972l84.165 4.199Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M109.723 125.227C99.017 134.434 85.083 140 69.85 140c-17.428 0-33.153-7.284-44.292-18.972l84.165 4.199Z"
      />
      <path
        fill="#D9D9D9"
        d="M61.144 139.386c.605-.464 1.18-.968 1.724-1.512a2 2 0 1 0-2.828-2.828 13.493 13.493 0 0 1-4.975 3.156c1.99.494 4.018.89 6.08 1.184Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M61.144 139.386c.605-.464 1.18-.968 1.724-1.512a2 2 0 1 0-2.828-2.828 13.493 13.493 0 0 1-4.975 3.156c1.99.494 4.018.89 6.08 1.184Z"
      />
      <path
        fill="#D9D9D9"
        fillRule="evenodd"
        d="M38.272 131.234a13.5 13.5 0 1 1 25.722-5.734c0 1.036-.318 1.897-.735 2.454-.417.556-.84.713-1.14.713-.3 0-.724-.157-1.14-.713-.418-.557-.735-1.418-.735-2.454v-6.458a2 2 0 0 0-3.642-1.142 9.75 9.75 0 1 0 1.856 13.225c.948.914 2.202 1.542 3.66 1.542 1.841 0 3.355-.999 4.34-2.313.986-1.313 1.536-3.036 1.536-4.854a17.5 17.5 0 1 0-34.852 2.272 61.375 61.375 0 0 0 5.13 3.462Zm16.288-9.8a5.752 5.752 0 0 1-4.066 9.816 5.751 5.751 0 0 1-4.066-9.816 5.751 5.751 0 0 1 8.132 0Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        fillRule="evenodd"
        d="M38.272 131.234a13.5 13.5 0 1 1 25.722-5.734c0 1.036-.318 1.897-.735 2.454-.417.556-.84.713-1.14.713-.3 0-.724-.157-1.14-.713-.418-.557-.735-1.418-.735-2.454v-6.458a2 2 0 0 0-3.642-1.142 9.75 9.75 0 1 0 1.856 13.225c.948.914 2.202 1.542 3.66 1.542 1.841 0 3.355-.999 4.34-2.313.986-1.313 1.536-3.036 1.536-4.854a17.5 17.5 0 1 0-34.852 2.272 61.375 61.375 0 0 0 5.13 3.462Zm16.288-9.8a5.752 5.752 0 0 1-4.066 9.816 5.751 5.751 0 0 1-4.066-9.816 5.751 5.751 0 0 1 8.132 0Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.817 124.854c.279-.248.556-.497.83-.748a.5.5 0 1 0-.676-.737c-.54.495-1.089.981-1.646 1.457a.496.496 0 0 0-.186.343.496.496 0 0 0 .467.547.506.506 0 0 0 .368-.13c.283-.241.564-.485.843-.732Zm3.274-4.556a.507.507 0 0 0-.106.555.493.493 0 0 0 .283.268.49.49 0 0 0 .39-.017.5.5 0 0 0 .159-.119 61.766 61.766 0 0 0 4.316-5.089.501.501 0 0 0-.797-.605 60.844 60.844 0 0 1-4.245 5.007Zm-9.417 9.343a.504.504 0 0 0 .209-.32.474.474 0 0 0-.002-.195.487.487 0 0 0-.215-.317.498.498 0 0 0-.377-.07.49.49 0 0 0-.179.076 60.716 60.716 0 0 1-3.7 2.336.499.499 0 0 0 .123.916.5.5 0 0 0 .38-.051 61.929 61.929 0 0 0 3.761-2.375Zm-5.706 3.46a.5.5 0 0 0-.472-.882c-18.15 9.695-39.99 9.416-57.774-.37a.49.49 0 0 0-.38-.042.494.494 0 0 0-.359.424.5.5 0 0 0 .256.494c18.08 9.947 40.278 10.232 58.729.376Zm24.138-25.146a.494.494 0 0 0-.043.38.497.497 0 0 0 .62.342.494.494 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.5.5 0 0 0-.883.47c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.501.501 0 0 0 .865-.503 60.76 60.76 0 0 0-2.374-3.762.5.5 0 0 0-.826.564 60.066 60.066 0 0 1 2.335 3.7v.001Zm-89.69 79.612a.492.492 0 0 0 .7-.097.49.49 0 0 0 .098-.37.501.501 0 0 0-.193-.33 60.521 60.521 0 0 1-5.007-4.244.498.498 0 0 0-.686.04.5.5 0 0 0-.001.687 61.529 61.529 0 0 0 5.09 4.314Zm-8.211-7.484a.5.5 0 1 0 .737-.676 61.999 61.999 0 0 1-.7-.776C2.462 93.874 4.83 55.586 29.907 33.401c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718 61.894 61.894 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a62.576 62.576 0 0 0-3.805-3.926.48.48 0 0 0-.065-.073 61.224 61.224 0 0 0-5.09-4.314.495.495 0 0 0-.128-.071 61.195 61.195 0 0 0-7.187-4.653.496.496 0 0 0-.146-.12c-18.08-9.949-40.278-10.234-58.728-.377a.498.498 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.549 61.549 0 0 0-3.762 2.375.5.5 0 0 0-.195.262 62.219 62.219 0 0 0-4.8 3.673.498.498 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.467 62.467 0 0 0-2.724 2.682.499.499 0 0 0-.29.151 61.682 61.682 0 0 0-4.316 5.089.498.498 0 0 0-.102.308 61.228 61.228 0 0 0-4.513 6.935.499.499 0 0 0-.234.215c-9.97 18.084-10.275 40.282-.434 58.727.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.3 61.3 0 0 0 2.373 3.763.496.496 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.043.048c.22.25.443.497.669.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.994 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.994 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM82.994 30.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 39.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 48.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 57.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 66.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 75.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.77 21H26.4a.905.905 0 0 0 0 1.81H38.77a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M83.089 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.225 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.453 24.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.214c7.403 0 13.404-5.997 13.404-13.394s-6.002-13.393-13.404-13.393c-7.403 0-13.404 5.996-13.404 13.393s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.353a1.675 1.675 0 1 0 0 3.348h3.351v3.349a1.676 1.676 0 0 0 3.351 0v-3.349h3.351a1.674 1.674 0 1 0 0-3.348h-3.35v-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="m85.252 34.304-.133.292 13.375 5.779v.5c5.263 0 9.979-2.34 13.165-6.035l.209-.244-.134-.292c-2.301-5.01-7.364-8.492-13.241-8.492s-10.939 3.481-13.24 8.492ZM120.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Zm-17.669-4.107a6.123 6.123 0 0 0-4.331-10.456 6.125 6.125 0 1 0 4.331 10.456Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="m85.252 34.304-.133.292 13.375 5.779v.5c5.263 0 9.979-2.34 13.165-6.035l.209-.244-.134-.292c-2.301-5.01-7.364-8.492-13.241-8.492s-10.939 3.481-13.24 8.492ZM120.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Zm-17.669-4.107a6.123 6.123 0 0 0-4.331-10.456 6.125 6.125 0 1 0 4.331 10.456Z"
      />
      <path
        stroke={primary}
        d="m85.252 34.304-.133.292 13.375 5.779v.5c5.263 0 9.979-2.34 13.165-6.035l.209-.244-.134-.292c-2.301-5.01-7.364-8.492-13.241-8.492s-10.939 3.481-13.24 8.492ZM120.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Zm-17.669-4.107a6.123 6.123 0 0 0-4.331-10.456 6.125 6.125 0 1 0 4.331 10.456Z"
      />
      <path
        fill={primary}
        d="M98.493 26.313c-5.674 0-10.563 3.36-12.786 8.2a16.839 16.839 0 0 0 12.787 5.862c5.111 0 9.691-2.272 12.786-5.862-2.223-4.84-7.112-8.2-12.787-8.2Zm5.626-11.25a5.62 5.62 0 0 1-3.473 5.196 5.623 5.623 0 0 1-7.777-5.197 5.625 5.625 0 1 1 11.25.001Z"
      />
      <path
        fill="#fff"
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M128.994 73.375h-1.044a1.125 1.125 0 0 0-1.075.794l-1.206 3.92c-.033.107-.05.218-.05.33V80.5a1.136 1.136 0 0 0 .329.796 1.135 1.135 0 0 0 .796.329h7.5a1.127 1.127 0 0 0 1.04-.694c.056-.137.085-.283.085-.431v-2.081c0-.112-.017-.224-.05-.33l-1.205-3.92a1.13 1.13 0 0 0-1.075-.794h-1.045m-6.375 4.875h1.93a1.123 1.123 0 0 1 1.006.622l.128.256a1.119 1.119 0 0 0 1.006.622h1.609a1.128 1.128 0 0 0 1.007-.622l.128-.256a1.119 1.119 0 0 1 1.006-.622h1.93M130.494 73v4.125m0 0-1.5-1.5m1.5 1.5 1.5-1.5"
      />
      <path
        fill="#fff"
        d="M130.744 17.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-10.5m19.5 0a2.25 2.25 0 0 0-2.25-2.25h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.253 2.253 0 0 1-1.07 1.916l-7.5 4.615a2.252 2.252 0 0 1-2.36 0l-7.5-4.614a2.25 2.25 0 0 1-1.07-1.916v-.244"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M130.744 17.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-10.5m19.5 0a2.25 2.25 0 0 0-2.25-2.25h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.253 2.253 0 0 1-1.07 1.916l-7.5 4.615a2.252 2.252 0 0 1-2.36 0l-7.5-4.614a2.25 2.25 0 0 1-1.07-1.916v-.244"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M130.744 17.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-10.5m19.5 0a2.25 2.25 0 0 0-2.25-2.25h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.253 2.253 0 0 1-1.07 1.916l-7.5 4.615a2.252 2.252 0 0 1-2.36 0l-7.5-4.614a2.25 2.25 0 0 1-1.07-1.916v-.244"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.427"
          y2="113.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Emails;
